<div class="c-form c-form--autorized">
  <div class="c-form__body">
    <div class="c-form__header">
      <div class="c-form__title c-form__title--dark">My IREV ID</div>
      <div class="c-form__subtitle">Single account across all services</div>
    </div>
    <div class="c-form__row">
      <div class="c-profile c-profile--mini">
        <div class="c-profile__header">
          <div class="c-profile__avatar">{{ user.fname[0] }}{{ user.lname[0] }}</div>
          <div class="c-profile__info">
            <div class="c-profile__title --dark">{{ user.fname }} {{ user.lname[0] }}.</div>
            <div class="c-profile__subtitle">{{ user.email }}</div>
          </div>
        </div>
        <div class="c-profile__navigation">
          <ul>
            <li>
              <a [href]="configService.docsUrl">
                <i class="icon icon-book"></i>
                Check out Documentation
              </a>
            </li>
            <li>
              <a [href]="configService.supportUrl" target="_blank">
                <i class="icon icon-support"></i>
                Help Center
              </a>
            </li>
            <li class="logout">
              <span class="c-link" (click)="logout()">
                <i class="icon icon-logout"></i>
                Log Out
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="c-form__row c-form__row c-form__row--submit">
      <a [href]="configService.controlUrl" class="c-button c-button--primary -large -full"
        >Go to Customer Area
        <span class="c-button__icon c-button__icon--small icon-arrow-1"></span>
      </a>
    </div>
  </div>
</div>
